<div *ngIf="currentView==='QuestionOption'"
     [ngClass]="survey && survey.definitionSections && survey.definitionSections.length ? 'displayStatus' : ''"
     class="simple-scroll flex flex-row justify-center items-start full-grow-no-shrink-no-basis">
  <ul class="action-btn-group">
    <li class="flex flex-col">
      <div class="header">Custom Survey Builder</div>
      <div class="content flex flex-col">
        <div>
          Create a custom survey by adding different questions (field types) based on your survey requirements
        </div>
        <img class="m-t-15"
             src="https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/survey-question-step01.png"
             alt="Custom Survey Builder">
      </div>
      <div class="footer flex flex-row justify-center items-center">
        <button mat-button class="action-button w-p-100 m-t-28" (click)="onAddQuestion()">Add Field</button>
      </div>
    </li>
    <li class="flex flex-col">
      <!--     <div class="ribbon ribbon-top-left"><span>Coming Soon</span></div>-->
      <div class="header">Upload Excel Template</div>
      <div class="content flex flex-col">
        <div>
          Upload an existing Excel template which will be converted into a compatible Orbitax Data Survey
        </div>
        <img class="m-t-15"
             src="https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/survey-question-step02.png"
             alt="Upload Excel Template">
      </div>
      <div class="footer flex flex-row justify-center items-center">
        <button mat-button class="action-button w-p-100 m-t-28" (click)="onUploadExcelTemplate()">Upload Template
        </button>
      </div>

    </li>
    <li layout="column">
      <div class="header">Select ITP Fields</div>
      <div class="content flex flex-col">
        <div>
          Select and include existing fields from your solutions in the International Tax Platform
        </div>
        <img class="m-t-15"
             src="https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/survey-question-step03.png"
             alt="Select Orbitax Fields">
      </div>
      <div class="footer flex flex-row justify-center items-center">
        <button mat-button class="action-button w-p-100 m-t-35" (click)="importFieldSections()">Select Fields</button>
      </div>
    </li>
  </ul>
</div>

<particle-excel-field-mapping *ngIf="currentView==='ExcelFieldMapping'"
                              [endpointName]="endpointName"
                              [workflow]="workflow"
                              [canEditField]="false"
>

</particle-excel-field-mapping>

<div particleHelpNotes helpNoteId="data-survey-stepup-questions" class="flex flex-col full-grow-no-shrink-no-basis"
     *ngIf="currentView==='SurveyFields'">
  <!--  <div fxLayout="row" >-->
  <!--    <mat-tab-group class="custom-mat-tab"-->
  <!--                   (selectedIndexChange)="onTabIndexChange($event)" [selectedIndex]="selectedFieldSectionIndex">-->
  <!--      <mat-tab *ngFor="let flowchart of flowcharts; let i = index" label="{{flowchart.header}}">-->
  <!--        <ng-template mat-tab-label>-->
  <!--          <div fxLayout="row" class="custom-tab-header" fxLayoutAlign="start center">-->
  <!--            <div fxLayout="column" fxLayoutAlign="start center">-->
  <!--              <div class="tool-name">{{flowchart.toolName}}</div>-->
  <!--              <div class="header">{{flowchart.productHeader}}</div>-->
  <!--            </div>-->
  <!--          </div>-->
  <!--        </ng-template>-->
  <!--        <div *ngIf="i === selectedFieldSectionIndex" class="hold-particle-flow-chart-container" fxLayout="column" fxLayoutAlign="start center">-->

  <!--        </div>-->
  <!--      </mat-tab>-->
  <!--    </mat-tab-group>-->
  <!--  </div>-->

  <particle-flow-chart-container></particle-flow-chart-container>
</div>


